import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const UserApi = createApi({
    reducerPath: "UserApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_URL}/api/admin/user`,
    }),
    tagTypes: ["Userlists"],
    endpoints: (builder) => ({
        getAllUser: builder.query({
            query: (id) => `/active/all/user/view/without/paginate/?id=${id}`,
            providesTags: (results, error) => [
                { type: "Userlists", results, error, id: "LIST" },
            ],
        }),
        getAllChatsUser: builder.query({
            query: (id) => `/active/chats/user/view/without/paginate?id=${id}`,
            providesTags: (results, error) => [
                { type: "Userlists", results, error, id: "LIST" },
            ], 
        }),
        getSingleUser: builder.query({
            query: (email) => `/by/email/view/${email}`,
            providesTags: (results, error) => [
                { type: "SingleUserByEmail", results, error, id: "LIST" },
            ],
        }),
        getSingleUserById: builder.query({
            query: (id) => `/by/id/view/${id}`,
            providesTags: (results, error) => [
                { type: "SingleUserById", results, error, id: "LIST" },
            ],
        }),
        getUserPermission: builder.query({
            query: (id) => `/user/permission/view/${id}`,
            providesTags: (results, error) => [
                { type: "UserPermission", results, error, id: "LIST" },
            ],
        }),

    }),
});

export const {
    useGetAllUserQuery,
    useGetAllChatsUserQuery,
    useGetSingleUserQuery,
    useGetSingleUserByIdQuery,
    useGetUserPermissionQuery
} = UserApi;
